import { defineRecipe } from '@chakra-ui/react';

export const headingRecipe = defineRecipe({
  className: 'chakra-heading',
  base: {
    fontFamily: 'heading',
    fontWeight: 'black',
    color: {
      _default: 'primary.dark',
      _dark: 'primary.light',
    },
  },
  variants: {
    size: {
      xs: {
        textStyle: 'xs',
      },
      sm: {
        textStyle: 'sm',
      },
      md: {
        textStyle: 'md',
      },
      lg: {
        textStyle: 'lg',
      },
      xl: {
        textStyle: {
          base: 'lg',
          sm: 'xl',
        },
      },
      '2xl': {
        textStyle: {
          base: 'xl',
          sm: '2xl',
        },
      },
      '3xl': {
        textStyle: {
          base: '2xl',
          sm: '3xl',
        },
      },
      '4xl': {
        textStyle: {
          base: '2xl',
          sm: '3xl',
          md: '4xl',
        },
      },
      '5xl': {
        textStyle: {
          base: '3xl',
          sm: '4xl',
          md: '5xl',
        },
      },
      '6xl': {
        textStyle: {
          base: '4xl',
          sm: '5xl',
          md: '6xl',
        },
      },
      '7xl': {
        textStyle: {
          base: '5xl',
          sm: '6xl',
          md: '7xl',
        },
      },
    },
  },
  defaultVariants: {
    size: '4xl',
  },
});
